"use client";

import { lazy } from "react";

export const LazyDevTools = lazy(() =>
  import(
    /* webpackChunkName: "retailer-dev-tools" */ "@faire/web--source/common/dev-tools/DevTools"
  ).then((m) => ({ default: m.DevTools }))
);
